export default __webpack_public_path__ + "static/scroll-05-c1d9f573f4dbfad7bd108186ac5869d0.jpg";